import { useEffect } from 'preact/hooks'

const createElement = (id: string, tag: string, content: string) => {
  const ele = document.createElement(tag)
  ele.innerHTML = content
  ele.id = id
  return ele
}

const useHead = (id: string, tag: string, content: string) => {
  const clearTag = () => {
    document.head.querySelectorAll(`#${id}`).forEach((ele) => ele.remove())
  }
  const insertTag = () => {
    const ele = createElement(id, tag, content)
    document.head.appendChild(ele)
  }
  useEffect(() => {
    insertTag()
    return clearTag
  }, [id, tag, content])
}

export default useHead
